
console.log('page.careers.js loaded');

// Utility to create unique values
function unique(arr) {
  return [...new Set(arr)];
}
function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

// ---------- DOM Helpers ----------
function generateJobList(job) {


  // const capitalizeWords = str => str.replace(/\b\w/g, char => char.toUpperCase());

  const cleanDescription = job.description.replace(/<p>(&nbsp;|\s)*<\/p>/gi, '');
  const locationAndDept = job.department 
  ? `${job.city}, ${job.state}, ${job.country} - ${job.department}`
  : `${job.city}, ${job.state}, ${job.country}`;
  
  const jobTitle = `
    <div class="job_title">
      <div class="job_meta">
        <strong>${job.title}</strong><br/>
        ${locationAndDept}
      </div>
      <button class="toggle_icon" aria-label="Toggle description">
        <svg focusable="false" width="10" height="10" viewBox="0 0 8 8" class="icon_plus">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5v3h2V5h3V3H5V0H3v3H0v2h3z" fill="currentColor"></path>
        </svg>
      </button>
    </div>
  `;

  const description = `
    <div class="job_description hidden">
      <h4 class="heading">Description</h4>
      ${cleanDescription}
      <div class="application_button"> 
      <a class="application_btn" href="${job.application_url}">Apply for this job</a>
      </div>
     
    </div>
  `;

  const li = document.createElement("li");
  li.className = "content_list";
  li.innerHTML = jobTitle + description;

  const toggleBtn = li.querySelector(".toggle_icon");
  const icon = toggleBtn.querySelector("svg");
  const desc = li.querySelector(".job_description");

  const plusPath = "M3 5v3h2V5h3V3H5V0H3v3H0v2h3z"; // plus
  const minusPath = "M0 3h8v2H0V3z"; // minus

  toggleBtn.addEventListener("click", e => {
    e.stopPropagation(); // prevent li click
    desc.classList.toggle("hidden");

    // toggle icon
    const pathEl = icon.querySelector("path");
    pathEl.setAttribute("d", desc.classList.contains("hidden") ? plusPath : minusPath);
  });

  // Optional: toggle when clicking anywhere on li
  li.addEventListener("click", () => {
    desc.classList.toggle("hidden");
    const pathEl = icon.querySelector("path");
    pathEl.setAttribute("d", desc.classList.contains("hidden") ? plusPath : minusPath);
  });

  return li;
}

function setJobDomContent(jobs) {
  const content = document.getElementById("careers_content");  // ← correct ID
  if (!content) {
    console.error("Job container #careers_content not found!");
    return;
  }
  content.innerHTML = "";
  jobs.forEach(job => content.appendChild(generateJobList(job)));
}

function generateFilterOption(values, selector) {
  const selectEl = document.querySelector(selector);
  values.forEach(val => {
    const option = document.createElement("option");
    option.value = val;
    option.textContent = val;
    selectEl.appendChild(option);
  });
}

function setJobFilters(jobs) {
  let countries = [];
  let departments = [];
  let workTypes = [];

  jobs.forEach(job => {
    const location = `${job.city}, ${job.state}, ${job.country}`;
    countries.push(location);
    departments.push(job.department);
    workTypes.push(job.employment_type.replace("-", " "));
  });

  generateFilterOption(unique(countries), ".location");
  generateFilterOption(unique(departments), ".careers_Department");
  generateFilterOption(unique(workTypes), ".work_type");
}

// ---------- Filtering ----------
function filterJobs(allJobs) {
  const searchValue = (document.querySelector(".careers__Search")?.value || "").trim().toLowerCase();
  const locationValue = document.querySelector(".location")?.value || "";
  const departmentValue = document.querySelector(".careers_Department")?.value || "";
  const workTypeValue = document.querySelector(".work_type")?.value || "";

  let filtered = allJobs.filter(job => {
    // Search filter
    if (searchValue && !job.title.toLowerCase().includes(searchValue)) return false;

    // Location filter
    if (locationValue && `${job.city}, ${job.state}, ${job.country}` !== locationValue) return false;

    // Department filter
    if (departmentValue && job.department !== departmentValue) return false;

    // Work type filter
    if (workTypeValue && job.employment_type.replace("-", " ") !== workTypeValue) return false;

    return true;
  });

  const content = document.getElementById("careers_content");  // ← correct ID
  content.innerHTML = "";

  if (filtered.length === 0) {
    content.innerHTML = `<h3 class="error_message">Sorry, no job found matching these criteria.</h3>`;
  } else {
    filtered.forEach(job => content.appendChild(generateJobList(job)));
  }
}

// ---------- Init ----------
// Async scripts may run after DOMContentLoaded (often on mobile); defer + readyState avoids a missed init.
function initCareers() {
  const container = document.getElementById("careers_content");
  if (!container) return;

  let allJobs = [];
  container.innerHTML = "<p>Loading jobs...</p>";

  fetch("https://apply.workable.com/api/v1/widget/accounts/arne?details=true")
    .then(res => {
      if (!res.ok) throw new Error("Failed to fetch jobs");
      return res.json();
    })
    .then(data => {
      console.log("Jobs data:", data);

      allJobs = Array.isArray(data.jobs) ? data.jobs : [];
      console.log(`Fetched ${allJobs.length} jobs.`);

      if (allJobs.length === 0) {
        container.innerHTML = "<p>No open positions right now.</p>";
        return;
      }

      setJobDomContent(allJobs);
      setJobFilters(allJobs);

      const searchInput = document.querySelector(".careers__Search");
      if (searchInput) {
        searchInput.addEventListener("keyup", () => {
          if (searchInput.value.length >= 3 || searchInput.value === "") {
            filterJobs(allJobs);
          }
        });
      }

      document.querySelectorAll(".wraper select").forEach(select => {
        select.addEventListener("change", () => filterJobs(allJobs));
      });
    })
    .catch(err => {
      console.error("Error:", err);
      if (container) {
        container.innerHTML = "<p style='color:red'>Failed to load jobs.</p>";
      }
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCareers);
} else {
  initCareers();
}
